export default {
    auth: {
        login: {
            title: 'เข้าสู่ระบบสำหรับคุณครู',
            buttons: {
                enter: 'เข้าสู่ระบบ',
                chathess: 'เข้าสู่ระบบด้วย Chathess',
                register: 'สมัครสมาชิก',
            },
        },
    },
    register: {
        title: 'สมัครสมาชิก',
        description: 'กรอกข้อมูลที่จำเป็นสำหรับการสมัครสมาชิก',
        chathessId: 'ไอดี Chathess',
        accountInfo: 'ข้อมูลบัญชี',
        accessId: 'ไอดี',
        password: 'รหัสผ่าน',
        passwordConfirm: 'ยืนยันรหัสผ่าน',
        buttons: {
            cancel: 'ยกเลิก',
            register: 'สมัครสมาชิก',
        },
    },
    home: {
        title: 'กดที่กิจกรรมเพื่อเริ่มการเรียนได้เลย',
    },
    self: {
        title: 'สถานะโหมดเรียนด้วยตนเอง',
        taskTitle: 'สถานะการทำการบ้าน',
        clear: 'เสร็จครบทุกคน!',
        tabs: {
            all: 'ดูทั้งหมด',
            completed: 'นักเรียนที่เสร็จแล้ว',
            inProgress: 'นักเรียนที่กำลังทำ',
        },
        noStudent: ({ values }: { values: { tab: string } }) => {
            const { tab } = values;

            if (tab === 'completed') {
                return 'ยังไม่มีนักเรียนที่เสร็จ';
            } else if (tab === 'in_progress') {
                return 'ยังไม่มีนักเรียนที่กำลังทำ';
            } else {
                return 'ยังไม่มีนักเรียน';
            }
        },
        table: {
            name: 'ชื่อ',
            progress: 'ความคืบหน้า',
            star: 'ดาวชมเชย',
            module: 'กิจกรรม',
            time: 'เวลาที่ใช้',
        },
    },
};
